export const EPIC_CLIENT_TOKEN_ENDPOINT = 'epicTokenEndpoint';
export const EPIC_CLIENT_AUTH_URL = 'epicAuthUrl';
export const EPIC_CLIENT_AUD = 'epicAud';
export const EPIC_CLIENT_LAUNCH_ISS = 'epicLaunchIss';
